<template>
  <el-form label-position="top" label-width="80px">
    <el-form-item label="客户信息">
      <el-input style="width:260px;" size="mini" maxlength="30" placeholder="请输入姓名/手机号/微信号" v-model="form.customerInfo">
      </el-input>
    </el-form-item>
    <el-form-item label="客户来源">
      <el-select size="mini" style="width:260px;" v-model="form.customerSource" placeholder="请选择">
        <el-option v-for="item in customerFlowSourcesUnion" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="意向级别">
      <el-select size="mini" style="width:260px;" v-model="form.intentionLevel" placeholder="请选择">
        <el-option v-for="item in customerIntentionLevels" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="到店时间">
      <el-date-picker
        v-model="form.arrivalTimeRang"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="datePickerOption"
        value-format="yyyy-MM-dd">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="离店时间">
      <el-date-picker
        v-model="form.leaveTimeRang"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="datePickerOption"
        value-format="yyyy-MM-dd">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="意向车系">
      <el-select size="mini" style="width:260px;" v-model="form.intentionSeries" placeholder="请选择">
        <el-option v-for="item in seriesListClone" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否试驾">
      <el-select size="mini" style="width:260px;" v-model="form.isTestDrive" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否报价">
      <el-select size="mini" style="width:260px;" v-model="form.hasOffer" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否关联订单">
      <el-select size="mini" style="width:260px;" v-model="form.isRelateOrder" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否自动创建">
      <el-select size="mini" style="width:260px;" v-model="form.isAutoCreate" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否订车">
      <el-select size="mini" style="width:260px;" v-model="form.hasBook" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否交车">
      <el-select size="mini" style="width:260px;" v-model="form.hasDeliver" placeholder="请选择">
        <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="创建人">
      <el-select size="mini" style="width:260px;" v-model="form.registerStaff" placeholder="请选择">
        <el-option v-for="item in registerStaffList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import { 
  genderList,
  datePickerOption,
  conditionSelectionList,
  payTypeList,
} from '../static/form-options'
import { deepClone } from '@/assets/js/util'

export default {
  name: 'SearchForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      genderList,
      conditionSelectionList,
      payTypeList,
      formClone: {},
      datePickerOption,
    }
  },
  computed: {
    baseInfo() {
      return this.$common.getBaseInfo()
    },
    // 客户来源
    customerFlowSourcesUnion() {
      return this.baseInfo.customerFlowSourcesUnion
    },
    // 客户意向级别
    customerIntentionLevels() {
      return this.baseInfo.customerIntentionLevels
    },
    // 页面对象
    pageVm() {
      return this.$parent.$parent
    },
    // 意向车系
    seriesListClone() {
      return deepClone(this.pageVm.seriesList)
    },
    // 现有车系
    currentSeriesClone() {
      return deepClone(this.pageVm.currentSeries)
    },
    // 对比车系
    compareSeriesClone() {
      return deepClone(this.pageVm.compareSeries)
    },
    // 试驾车型
    testDriveModelClone() {
      return deepClone(this.pageVm.testDriveModel)
    },
    registerStaffList() {
      const profile = this.$common.getDealer();
      return [
        { label: '全部', value: null },
        { label: '我创建的', value: profile.userId },
      ]
    },
  },
  mounted() {
    console.log(this.$parent.$parent)
  },
  methods: {
  }
}
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item .el-form-item__label {
  line-height: 16px;
  padding-bottom: 3px;
}
/* ::v-deep .date-box {
  display: flex;
}
.date-box ::v-deep .el-date-editor--data.el-input {
  width: 160px;
}
.date-box ::v-deep .el-date-editor--time-select.el-input {
  width: 140px;
}
.date-box ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 26px;
  padding-right: 26px;
  font-size: 12px;
}
.date-box ::v-deep .el-input__icon {
  width: 14px;
  line-height: 28px;
} */
</style>